module.exports = __webpack_public_path__ + "img/subli_negro.54ca1530.jpg";